import { render, staticRenderFns } from "./ChildAgeSelect.vue?vue&type=template&id=4d9f02e1&scoped=true"
import script from "./ChildAgeSelect.vue?vue&type=script&lang=js"
export * from "./ChildAgeSelect.vue?vue&type=script&lang=js"
import style0 from "./ChildAgeSelect.vue?vue&type=style&index=0&id=4d9f02e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f02e1",
  null
  
)

export default component.exports